export default function Expertise() {
  const expertise = [
    {
      icon: 'ri-building-4-line',
      color: 'teal',
      title: 'Entreprise Générale',
      description: 'Gestion complète de vos projets de construction et rénovation en Suisse romande. Coordination de tous les corps de métier, budgétisation, planification et surveillance des travaux pour une livraison clé en main.'
    },
    {
      icon: 'ri-file-chart-line',
      color: 'teal',
      title: 'Conseil et Gestion de Projets',
      description: 'Accompagnement stratégique complet : conseil technique CVSE, budgétisation précise, planification détaillée et suivi de chantier à Genève et dans toute la Suisse romande.'
    },
    {
      icon: 'ri-tools-fill',
      color: 'teal',
      title: 'Installations CVSE Complètes',
      description: 'Expertise technique dans tous les domaines : chauffage (pompes à chaleur), ventilation (VMC), sanitaire (plomberie) et électricité (NIBT/OIBT). Solutions sur mesure conformes aux normes suisses.'
    },
    {
      icon: 'ri-home-smile-line',
      color: 'teal',
      title: 'Gestion Immobilière',
      description: 'Services immobiliers commerciaux : achat, vente, courtage, gestion et location de biens. Expertise technique pour l\'évaluation et l\'optimisation de vos actifs immobiliers professionnels.'
    },
    {
      icon: 'ri-leaf-line',
      color: 'teal',
      title: 'Solutions Éco-Responsables',
      description: 'Installations durables et produits écologiques : pompes à chaleur, VMC double flux, domotique intelligente. Réduction de votre empreinte carbone et économies d\'énergie garanties.'
    },
    {
      icon: 'ri-shield-star-line',
      color: 'teal',
      title: 'Certifications et Conformité',
      description: 'Entreprise certifiée et agréée pour tous travaux CVSE en Suisse. Respect strict des normes OIBT/NIBT, certifications officielles et garantie de conformité totale sur chaque chantier.'
    }
  ];

  const reasons = [
    {
      icon: 'ri-user-star-line',
      title: 'Équipe Certifiée & Qualifiée',
      description: 'Techniciens diplômés, formation continue aux normes OIBT/NIBT. Chaque intervenant est certifié pour son domaine.'
    },
    {
      icon: 'ri-map-pin-2-line',
      title: 'Présence en Suisse Romande',
      description: 'Basés à Neuenegg (FR), nous intervenons dans les cantons romands : Fribourg, Berne, Vaud, Valais, Neuchâtel, Jura.'
    },
    {
      icon: 'ri-time-line',
      title: 'Urgence 24h/24 — 7j/7',
      description: 'Service d\'urgence disponible à toute heure. Intervention rapide garantie dans tout le canton de Genève et régions limitrophes.'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Devis Gratuit & Transparent',
      description: 'Estimation gratuite et sans engagement. Tarifs clairs, pas de mauvaises surprises. Rapport qualité-prix optimal.'
    },
    {
      icon: 'ri-recycle-line',
      title: 'Engagement Éco-Responsable',
      description: 'Solutions durables, produits écologiques et matériaux certifiés. Nous contribuons activement à la transition énergétique suisse.'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Documentation & Garanties',
      description: 'Plans as-built, certificats de conformité, manuels d\'utilisation. Garantie étendue sur toutes nos installations.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Suivi Client Personnalisé',
      description: 'Un interlocuteur dédié du devis à la réception des travaux. Réponse sous 24h, accompagnement complet et service après-vente réactif.'
    },
    {
      icon: 'ri-award-line',
      title: 'Multi-Services sous un Seul Toit',
      description: 'Électricité, chauffage, sanitaire, ventilation, domotique, rénovation — tout chez CasaReNovaPlus, sans multiplier les intervenants.'
    },
  ];

  return (
    <section id="expertise" className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">

        {/* Header */}
        <div className="mx-auto max-w-2xl text-center mb-16">
          <h2 className="text-base font-semibold leading-7 text-teal-600">Notre Expertise</h2>
          <p className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            Excellence Technique et Savoir-Faire
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            Une expertise pointue développée sur des dizaines de projets réalisés à Genève et en Suisse romande.
          </p>
        </div>

        {/* Expertise cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-20">
          {expertise.map((area, index) => (
            <div key={index} className="bg-white rounded-2xl p-7 border border-gray-100 hover:border-teal-200 transition-all group">
              <div className="flex items-start gap-5">
                <div className="w-14 h-14 flex items-center justify-center bg-teal-50 group-hover:bg-teal-100 rounded-xl flex-shrink-0 transition-colors">
                  <i className={`${area.icon} text-2xl text-teal-600`}></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{area.title}</h3>
                  <p className="text-gray-600 leading-relaxed text-sm">{area.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Image bannière rénovation */}
        <div className="relative rounded-2xl overflow-hidden mb-20 h-64 md:h-80">
          <img
            src="https://readdy.ai/api/search-image?query=beautiful%20Swiss%20residential%20home%20renovation%20in%20progress%20interior%20transformation%20with%20modern%20open%20kitchen%20being%20installed%20exposed%20brick%20and%20wooden%20flooring%20professional%20craftsmen%20at%20work%20warm%20natural%20lighting%20earth%20tones%20and%20natural%20materials%20high-end%20residential%20remodeling%20clean%20organized%20workspace%20professional%20architectural%20photography%20with%20simple%20warm%20neutral%20background&width=1200&height=400&seq=renovation-banner-expertise&orientation=landscape"
            alt="Chantier de rénovation CasaReNovaPlus en cours"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/30 to-transparent"></div>
          <div className="absolute inset-0 flex items-center">
            <div className="px-8 md:px-12 max-w-lg">
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-2">Rénovation sur mesure</h3>
              <p className="text-white/80 text-sm md:text-base leading-relaxed">
                De la démolition à la finition, nous gérons chaque étape de votre projet avec rigueur et passion.
              </p>
            </div>
          </div>
        </div>

        {/* Pourquoi nous choisir — layout avec image */}
        <div className="grid grid-cols-1 lg:grid-cols-5 rounded-2xl border border-gray-100 overflow-hidden">
          {/* Image colonne */}
          <div className="lg:col-span-2 relative min-h-[300px] lg:min-h-[500px]">
            <img
              src="https://readdy.ai/api/search-image?query=professional%20team%20of%20construction%20workers%20collaborating%20on%20a%20Swiss%20house%20renovation%20project%20measuring%20and%20planning%20on%20site%20with%20tools%20and%20blueprints%20warm%20natural%20sunlight%20earth%20tones%20clean%20professional%20atmosphere%20high-end%20craftsmanship%20architectural%20photography%20with%20simple%20neutral%20warm%20background&width=500&height=600&seq=renovation-team-expertise&orientation=portrait"
              alt="Équipe de rénovation CasaReNovaPlus au travail"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent lg:bg-gradient-to-r"></div>
            <div className="absolute bottom-4 left-4 right-4 lg:bottom-6 lg:left-6">
              <span className="inline-flex items-center gap-2 rounded-lg bg-white/90 backdrop-blur-sm px-4 py-2 text-xs font-semibold text-gray-900">
                <i className="ri-hammer-line text-teal-600"></i>
                Artisans qualifiés
              </span>
            </div>
          </div>

          {/* Contenu colonne */}
          <div className="lg:col-span-3 bg-white flex flex-col">
            <div className="bg-gradient-to-r from-teal-600 to-teal-700 px-8 md:px-10 py-8">
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-2">Pourquoi Choisir CasaReNovaPlus ?</h3>
              <p className="text-teal-100 text-sm">Toutes les raisons de nous faire confiance pour vos projets en Suisse romande</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-0 divide-y sm:divide-y-0 sm:divide-x divide-gray-100 flex-1">
              {reasons.slice(0, 4).map((r, i) => (
                <div key={i} className="p-5 md:p-6 hover:bg-teal-50/50 transition-colors group">
                  <div className="w-10 h-10 flex items-center justify-center bg-teal-100 group-hover:bg-teal-200 rounded-lg mb-3 transition-colors">
                    <i className={`${r.icon} text-teal-600 text-lg`}></i>
                  </div>
                  <h4 className="font-bold text-gray-900 text-sm mb-1">{r.title}</h4>
                  <p className="text-gray-500 text-xs leading-relaxed">{r.description}</p>
                </div>
              ))}
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-0 divide-y sm:divide-y-0 sm:divide-x divide-gray-100 border-t border-gray-100">
              {reasons.slice(4).map((r, i) => (
                <div key={i} className="p-5 md:p-6 hover:bg-teal-50/50 transition-colors group">
                  <div className="w-10 h-10 flex items-center justify-center bg-teal-100 group-hover:bg-teal-200 rounded-lg mb-3 transition-colors">
                    <i className={`${r.icon} text-teal-600 text-lg`}></i>
                  </div>
                  <h4 className="font-bold text-gray-900 text-sm mb-1">{r.title}</h4>
                  <p className="text-gray-500 text-xs leading-relaxed">{r.description}</p>
                </div>
              ))}
            </div>
            <div className="px-8 md:px-10 py-6 bg-gray-50 border-t border-gray-100 flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-gray-600 text-sm">
                Prêt à démarrer votre projet ? Contactez-nous pour un <strong className="text-teal-600">devis gratuit</strong>.
              </p>
              <a
                href="#contact"
                className="rounded-lg bg-teal-600 px-6 py-3 text-sm font-semibold text-white hover:bg-teal-700 transition-all whitespace-nowrap cursor-pointer"
              >
                Demander un devis gratuit
              </a>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
